import { render } from "./CopyStation.vue?vue&type=template&id=1cbe81a3"
import script from "./CopyStation.vue?vue&type=script&lang=js"
export * from "./CopyStation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__